module.exports = __webpack_public_path__ + "img/ereszkalkulator_kicsi_haz_felnyeregteto_szines.2ec7e3ea.png";